module.exports = __webpack_public_path__ + "img/bootstrap.743df582.svg";